var layout_default = {
  "layout": "_26eQP",
  "cell": "dzLem"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
